import { useState, useEffect } from 'react';

const MOBILE_SHELL_QUERY = '(max-width: 1023px)';

export function useMobileShell(): boolean {
  const [isMobileShell, setIsMobileShell] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(MOBILE_SHELL_QUERY).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(MOBILE_SHELL_QUERY);
    const handler = (event: MediaQueryListEvent) => setIsMobileShell(event.matches);
    setIsMobileShell(media.matches);
    if (media.addEventListener) {
      media.addEventListener('change', handler);
      return () => media.removeEventListener('change', handler);
    }
    media.addListener(handler);
    return () => media.removeListener(handler);
  }, []);

  return isMobileShell;
}
